import { render, staticRenderFns } from "./DataTable4.vue?vue&type=template&id=5669bace&scoped=true"
import script from "./DataTable4.vue?vue&type=script&lang=js"
export * from "./DataTable4.vue?vue&type=script&lang=js"
import style0 from "./DataTable4.vue?vue&type=style&index=0&id=5669bace&prod&lang=scss&scoped=true"
import style1 from "./DataTable4.vue?vue&type=style&index=1&id=5669bace&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5669bace",
  null
  
)

export default component.exports